import { useQuery } from "@tanstack/react-query";

import { integrationsApi } from "../api/integrations.api";
import type { IntegrationModuleQueryParams } from "../types";

// Query key factory for integration modules
export const integrationModulesKeys = {
  all: ['integrationModules'] as const,
  byIntegration: (integrationName: string) => [...integrationModulesKeys.all, integrationName] as const,
  list: (params: IntegrationModuleQueryParams) => 
    [...integrationModulesKeys.byIntegration(params.integrationName), 'list', params] as const,
} as const;

/**
 * Hook for fetching integration modules
 * Returns React Query result directly - use isPending, isError, data, error properties
 */
export function useIntegrationModules(params: IntegrationModuleQueryParams) {
  return useQuery({
    queryKey: integrationModulesKeys.list(params),
    queryFn: () => integrationsApi.fetchIntegrationModules(params),
    staleTime: 20 * 60 * 1000, // 20 minutes
    // Only fetch if integrationName is provided.
    enabled: !!params.integrationName,
  });
}
